import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import sessionStorage from 'redux-persist/lib/storage/session'
import {evt, evts, opertionEvts , levelShares ,twoLevelShares,wxLevelShareStatis,
    wxLevelShareAttendees,checkinCredits ,codeShares ,guestGroups ,eventGroups,
    eventCommentPages,eventComments} from './evt';
import {user, users, loginedUser,userBuyVas,userQcoinTrans,userCashTransTypes} from './user';
import {userAddress, userAddresses} from './userAddress';
import {role, roles} from './role';
import {checkinlogs,allcheckinlogs,allregisterlogs, gpbyattds} from './checkin';
import {registration, registrations} from './registration';
import {checkinpoint, checkinpoints} from './checkinpoint';
import {contact, contacts, cttgroups, cttgps} from './contact';
import {withdraw, withdraws} from './withdraw';
import {invoice, invoices, invoiceStats ,attendeeInvoices} from './invoice';
import {invitationTpl, invitationTpls} from './invitationTpl';
import {invitationBgm, invitationBgms} from './invitationBgm';
import {invitation, invitations} from './invitation';
import {pcversion, pcversions} from './pcClient';
import {customer, customers} from './customerConfig';
import {ibeacons} from './ibeaconConfig';
import { msglogs } from './msglog';
import {attendee, attendees, tasks,attendeesprint ,attendeeLevelShare} from './attendee';
import {ios, ioss} from './ios';
import {androidClient, androidClients} from './androidClient';
import {cmEnums} from './cmenums';
import {global, loginByOauth} from './global';
import {ticketOrders, vasOrders ,luckMoneyOrders,rewardOrders,marketOrders,orders} from './cmOrder';
import {courier} from './courier';
import {feedback, feedbacks,evtFeedbacks} from './feedback';
import {onlineUserTokens, onlineUsers, onlineUserCountStats} from './onlineUser';
import {invoiceVerifys} from './invoiceVerify';
import {bankcardVerifys} from './bankcardVerify';
import { smssignVerifys } from './smssignVerify';

import {withdrawVerifys} from './withdrawVerify';
import {refundVerifys} from './refundVerify';
import selectedRowKey from './selectedRowKey';
import {extendForms} from './qaForm';
import {shopingCart} from './shopingCart';
import {createWhitelistFilter} from "redux-persist-transform-filter";
import {tickets} from "./ticket";
import {informationNumber} from "./informationNumber";
import {drawpool,winners,rollpool,rollpools, adminRollpools, attendeewinners,rollpoolBwLists,drawpoolBwLists} from "./luckydraw";
import { promotes } from "./promote";
import { allots } from "./allot";
import { exceptConfigs } from "./exceptConfig";
import { broadcasts } from "./dynamic";
import { smsFilters } from "./smsConfig";
import { questionnaires ,surveyAnswers,votes, adminQuestionnaires, adminVotes } from "./questionnaires";
import { barrageConfigs,barrageMessage} from "./barrage";
import { articles } from "./website";
import { luckyMoneys , winnerDetails} from "./luckyMoney";
import { microsites } from "./microsite";
import { experiences } from "./experience";
import { signinWallMessageRecents } from "./signinWall";
import { rewards ,rewardDetails,rewardTargets} from "./reward";
import { markets,marketGoods,marketPurchases} from "./market";
import { guesss ,guessGoods,guessRankings} from "./guess";
import { cusWjws ,cusWjwMake } from "./customization";
import { subAccountEventsApplys } from "./subAccount";
import {wechatMerchants, alipayMerchants, merchantList} from "./payConfig";


const sessionStoragePersistConfig = {
    key: 'root',
    storage: sessionStorage,
    transforms: [
        createWhitelistFilter('cmEnums', []),
        createWhitelistFilter('shopingCart', [])
    ]
};

const rootReducer = combineReducers({
    merchantList,
    alipayMerchants,
    wechatMerchants,
    subAccountEventsApplys,
    cusWjws,
    cusWjwMake,
    guessRankings,
    guessGoods,
    guesss,
    markets,
    marketGoods,
    marketPurchases,
    rewardTargets,
    rewardDetails,
    rewards,
    signinWallMessageRecents,
    userBuyVas,
    userQcoinTrans,
    userCashTransTypes,
    drawpoolBwLists,
    rollpoolBwLists,
    experiences,
    microsites,
    orders,
    marketOrders,
    rewardOrders,
    luckMoneyOrders,
    winnerDetails,
    luckyMoneys,
    articles,
    barrageMessage,
    barrageConfigs,
    attendeesprint,
    attendeeLevelShare,
    votes,
    adminVotes,
    surveyAnswers,
    questionnaires,
    adminQuestionnaires,
    smsFilters,
    broadcasts,
    allots,
    exceptConfigs,
    attendeewinners,
    rollpools,
    adminRollpools,
    rollpool,
    promotes,
    drawpool,
    winners,
    informationNumber,
    loginByOauth,
    tickets,
    tasks,
    invoiceVerifys,
    bankcardVerifys,
    smssignVerifys,
    withdrawVerifys,
    refundVerifys,
    global,
    cmEnums: cmEnums,
    shopingCart: shopingCart,
    evt,
    evts,
    opertionEvts,
    levelShares,
    twoLevelShares,
    wxLevelShareStatis,
    wxLevelShareAttendees,
    checkinCredits,
    codeShares,
    guestGroups,
    eventGroups,
    eventCommentPages,
    eventComments,
    attendee,
    attendees,
    user,
    users,
    loginedUser,
    userAddress,
    userAddresses,
    role,
    roles,
    checkinlogs,
    allcheckinlogs,
    allregisterlogs,
    gpbyattds,
    registration,
    registrations,
    checkinpoint,
    checkinpoints,
    contact,
    contacts,
    cttgroups,
    cttgps,
    withdraw,
    withdraws,
    invoice,
    invoices,
    invoiceStats,
    attendeeInvoices,
    invitationTpl,
    invitationTpls,
    invitationBgm,
    invitationBgms,
    invitations,
    invitation,
    pcversion,
    pcversions,
    customer,
    customers,
    ibeacons,
    ios,
    ioss,
    androidClient,
    androidClients,
    ticketOrders,
    vasOrders,
    courier,
    feedback,
    feedbacks,
    evtFeedbacks,
    onlineUserTokens,
    onlineUsers,
    onlineUserCountStats,
    selectedRowKey,
    extendForms,
    msglogs,
});

export default rootReducer


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js